import { createContext } from "react";
const PostBackgroundContext = createContext({});

export default PostBackgroundContext;
